import React from 'react';
import * as keyset from 'i18n/DraftControlPanel';
import i18n from '@yandex-int/i18n';
import { getIsYangoRequest } from '../../utils';

const t = i18n(keyset);

export const getSmartHomeTestingChecklistTexts = () =>
    t(getIsYangoRequest() ? 'checklist-sh-texts-yango' : 'checklist-sh-texts-yandex')
        .split('\n')
        .map((s, idx) => <span key={idx} dangerouslySetInnerHTML={{ __html: s }} />);

export const smartHomeTestingTitleText = t('sh-testing-text');
